<section class="section py-6">
    <div class="columns">
      <div class="column header-title-page">
        <h2 class="title-header">Materiales</h2>
        <button class="button is-primary" (click)="openModal()">Nuevo material</button>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <div class="field">
          <label class="label">Buscar</label>
          <p class="control has-icons-left">
            <input class="search-bar input" type="text" placeholder="Buscar..." [(ngModel)]="filters.search.value"
            (keyup.enter)="onFilter()">
            <span class="icon is-left">
              <fa-icon class="icon-search" [icon]="faMagnifyingGlass"></fa-icon>
            </span>
          </p>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label">Value stream</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select [(ngModel)]="filters.value_stream.value" (ngModelChange)="onFilter()">
                <option value="">Todos</option>
                <option *ngFor="let vs of valueStreamValues" [value]="vs">{{ vs }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section py-1">
    <div class="columns has-background-white">
      <div class="column">
        <div class="columns">
          <div class="column p-5">
            @if(materials) {
              <div class="table-products">
                <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="materialsFiltered"
                  (onSelectRow)="openModal($event)" (onDeleteItem)="delete($event)"></app-generic-table>
              </div>
            }

          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="modal" [ngClass]="{'is-active': isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <form [formGroup]="form" (ngSubmit)="onSave()">
        <header class="modal-card-head">
          @if(isCreating) {
          <p class="modal-card-title">Nuevo Material</p>
          }@else {
          <p class="modal-card-title">Material: {{ form.value.fert }}</p>
          }
          <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <!-- @if(isCreating) {
                <div class="field">
                  <label class="label">Id</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Id" formControlName="id">
                  </div>
                </div>
              } -->
              
              <div class="field">
                <label class="label">Activo</label>
                <input id="isActiveSwitch" type="checkbox" name="isActiveSwitch" class="switch is-rounded"
                  formControlName="active">
                <label for="isActiveSwitch"></label>
              </div>
              <div class="field">
                <label class="label">Fert</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Fert" formControlName="fert">
                </div>
              </div>
              <div class="field">
                <label class="label">Material</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Material" formControlName="description">
                </div>
              </div>


              <div class="field">
                <label class="label">Peso</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Peso" formControlName="weight">
                </div>
              </div>

              <div class="field">
                <label class="label">Grad</label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="product">
                      <option *ngFor="let product of products" [ngValue]="product">
                        {{ product.id }} - {{ product.description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="field">
                <label class="label">Envase</label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="packaging">
                      <option *ngFor="let package of packages" [ngValue]="package">
                        {{ package.id }} - {{ package.description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="field">
                <label class="label">Value stream</label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="value_stream">
                      <option *ngFor="let vs of valueStreamValues" [value]="vs">{{ vs }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
          <button type="button" class="button" (click)="closeModal()">Cancelar</button>
          <button type="submit" class="button is-primary" [disabled]="!form.valid">
            @if(isLoading) {
            <fa-icon [icon]="faSpinner"></fa-icon>
            }@else {
            <span>Guardar</span>
            }
          </button>
        </footer>
      </form>
    </div>
  </div>
  